var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":false,"is-full-page":true,"height":150,"width":150,"color":'#FFFF00',"background-color":'#000000',"opacity":0.5},on:{"update:active":function($event){_vm.isLoading=$event}}}),(!_vm.isLoading)?_c('app-form',{attrs:{"parentObject":{
        data: this.formData,
        pageTitle: this.pageTitle,
        isEdit: this.isEdit,
    }},on:{"input":function($event){_vm.formData = $event},"save":_vm.saveHandler,"error":_vm.errorHandler}}):_vm._e(),(_vm.isErr)?_c('div',[_c('app-error',{attrs:{"parentError":{
            data: this.errMsg,
            isErr: this.isErr,
        }},on:{"closeError":function($event){_vm.isErr = $event}}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }